import type { LeasingUserDTO, UserContext } from '#types/types';

export const URW_ORGANISATION_ID = '6805178236d71277f7dbd45f';

const URW_ADMIN_NAME_TOKENS = ['thibaut', 'sydney', 'jean baptiste', 'jean-baptiste', 'sing'];

const normalizeIdentityText = (value: unknown): string =>
  String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

const identityMatchesUrwAdmin = (parts: unknown[]): boolean => {
  const normalized = normalizeIdentityText(parts.filter(Boolean).join(' '));
  if (!normalized) return false;
  return URW_ADMIN_NAME_TOKENS.some((token) => normalized.includes(normalizeIdentityText(token)));
};

const isUrwOrganisation = (organisationId: string | null | undefined, organisationName?: unknown): boolean => {
  if (organisationId === URW_ORGANISATION_ID) return true;
  const normalizedName = normalizeIdentityText(organisationName);
  return normalizedName.includes('urw') || normalizedName.includes('unibail') || normalizedName.includes('westfield');
};

export function isUrwProjectDashboardAdmin(input: {
  userContext: UserContext;
  user?: Pick<LeasingUserDTO, 'firstName' | 'lastName' | 'email' | 'organisationId'> | null;
  organisation?: { id?: string | null; name?: string | null } | null;
}): boolean {
  const { userContext, user, organisation } = input;
  if (!userContext.isOrganisationAdmin) return false;
  if (!isUrwOrganisation(userContext.organisationId ?? user?.organisationId ?? organisation?.id, organisation?.name)) return false;

  const effectiveProfile = userContext.isImpersonating ? userContext.impersonatedUser : userContext.trueUser;
  return identityMatchesUrwAdmin([
    user?.firstName,
    user?.lastName,
    user?.email,
    effectiveProfile?.name,
    effectiveProfile?.email,
  ]);
}
